export {renderBarIcon} from './BarIcon';
